import { render } from "./RegisterLogin.vue?vue&type=template&id=2aa919c4&scoped=true"
import script from "./RegisterLogin.vue?vue&type=script&lang=js"
export * from "./RegisterLogin.vue?vue&type=script&lang=js"

import "./RegisterLogin.vue?vue&type=style&index=0&id=2aa919c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HS\\Desktop\\fikstur\\my_fiksture\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa919c4"]])

export default __exports__